<template>
  <div class="pb-5" :class="[validatedSectionClass, generalClass]">
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <form @submit.prevent="validate(true)">
            <label class="control-label required" for="siteCode"
                    v-html="computeCaption(siteCodeCaption, $store.state.lang.value.toLowerCase())">
            </label>
            <div>
              <small class="text-danger" v-if="verbiage">
                *{{ computeCaption(verbiage, $store.state.lang.value.toLowerCase()) }}
              </small>
            </div>
            <input class="form-control"
                  data-vv-as="Office location code"
                  id="siteCode"
                  type="text"
                  aria-required="true"
                  name="siteCode"
                  v-validate="modelValidations.siteCode"
                  v-model="model.siteCode"
                  placeholder="ex: 12345678"
                   onkeydown="if (arguments[0].code === undefined){ return false } if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
          </form>
          <br>
          <small class="text-danger" v-show="siteCode.invalid">
            {{getError('siteCode') && computeCaption(getError('siteCode'), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
    <div class="col-md-2 col-md-offset-1 pl-0">
      <language-button id="mobile-language"></language-button>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import axios from 'axios'
  import LanguageButton from '../../LanguageButton'
  import swal from 'sweetalert2'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  export default {
    components: {
      LanguageButton
    },
    mixins: [TranslationsUtils, SettingsUtils],
    props: {
      siteCodeCaption: {
        type: String,
        default: 'Office Location Code'
      }
    },
    data () {
      return {
        generalClass: 'general-inactive-section',
        validatedSectionClass: '',
        validateTransaction: true,
        fields_en: {
          office_location_code: 'Office Location Code'
        },
        model: {
          siteCode: null,
          transaction_id: null
        },
        modelValidations: {
          siteCode: {
            min: 2,
            required: true
          }
        }
      }
    },
    mounted () {
      if (this.$route.query.transaction_id) {
        this.model.transaction_id = this.$route.query.transaction_id
        this.checkTransactionId()
      }
      if (this.$route.query.site_code) {
        this.model.siteCode = this.$route.query.site_code
        this.validate(true)
        this.$emit('disabledSubmitButton', true)
      }
      this.$store.state.personIdentifierSection = {
        med_social_security_number: '',
        med_driver_license_number: ''
      }
    },
    methods: {
      checkTransactionId () {
        axios.get(process.env.SERVER_URI + '/validate/transation/id/' + this.$route.query.site_code + '/' + this.model.transaction_id)
        .then((response) => {
          this.$store.state.medicalData.first_name = response.data.first_name
          this.$store.state.medicalData.last_name = response.data.last_name
          this.$store.state.medicalData.address = response.data.address
          this.$store.state.medicalData.address2 = response.data.address2
          this.$store.state.medicalData.email = response.data.email
          this.$store.state.medicalData.phone = response.data.phone
        }).catch((error) => {
          if (error.response.status === 429) {
            swal('Error!', 'It looks like you already registered! Please check your email for the confirmation number or try again later', 'error')
            .then(function (result) {
              window.location.reload()
            })
            .catch(swal.noop)
            this.validateTransaction = false
            this.redirect()
          }
        })
      },
      redirect () {
        const body = document.querySelector('body')
        const self = this
        body.onclick = function () {
          self.$router.push({ path: '/' })
          window.location.reload()
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      jumpToTheNextPage () {
        this.$emit('jumpToTheNextPage')
      },
      validate (nextPage) {
        if (this.model.siteCode && this.model.siteCode.length >= 2) {
          return new Promise((resolve, reject) => {
            this.$store.state.invalidSiteCode = false
            this.model.validatedSiteCode = null
            axios.get(process.env.SERVER_URI + '/validate/site/' + this.model.siteCode).then(async (response) => {
              if (response.data === false) {
                this.$emit('disabledSubmitButton', false)
                this.$validator.errors.add({field: 'siteCode', msg: 'Invalid Code!'})
                let field = this.$validator._resolveField('siteCode')
                field.setFlags({invalid: true})
                document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
                this.$store.state.invalidSiteCode = true
                this.validatedSectionClass = 'invalid-section-class'
                this.generalClass = 'general-invalid-section'
                reject(new Error('Invalid site code!!'))
              } else {
                this.$store.state.site = response.data
                this.$store.state.sitecode = this.model.siteCode
                if (response.data['logo']) {
                  this.$store.state.logo = response.data['logo']
                }
                if (response.data['required_dl_or_ssn'] === true || response.data['required_dl_or_ssn'] === false) {
                  this.$store.state.dl_or_ssn_required_by_client = response.data['required_dl_or_ssn']
                }
                if (response.data['allow_dl_or_ssn'] === true || response.data['allow_dl_or_ssn'] === false) {
                  this.$store.state.allow_dl_or_ssn = response.data['allow_dl_or_ssn']
                }
                if (response.data['required_uninsured_ssn'] === true || response.data['required_uninsured_ssn'] === false) {
                  this.$store.state.required_uninsured_ssn = response.data['required_uninsured_ssn']
                }
                if (response.data['required_insurance_ssn'] === true || response.data['required_insurance_ssn'] === false) {
                  this.$store.state.required_insurance_ssn = response.data['required_insurance_ssn']
                }
                if (response.data['redirect_registration_url']) {
                  this.$store.state.redirect_registration_url = response.data['redirect_registration_url']
                }
                if (response.data['redirect_payment_url']) {
                  this.$store.state.redirect_payment_url = response.data['redirect_payment_url']
                }
                if (response.data['restrict_email_to_domain']) {
                  this.$store.state.restrict_email_to_domain = response.data['restrict_email_to_domain']
                }

                this.overwriteGraphSettings(response.data)
                // process.env.NODE_ENV = 'testing'
                let one = process.env.SERVER_URI + '/requirements/' + this.model.siteCode
                let two = process.env.SERVER_URI + '/questions/' + this.model.siteCode
                let three = process.env.SERVER_URI + '/insurance/' + this.model.siteCode
                let four = process.env.SERVER_URI + '/ethnicity/' + this.model.siteCode
                let five = process.env.SERVER_URI + '/race/' + this.model.siteCode
                let six = process.env.SERVER_URI + '/gender/' + this.model.siteCode
                let seven = process.env.SERVER_URI + '/allows_client_bill/' + this.model.siteCode
                let eight = process.env.SERVER_URI + '/calculations/' + this.model.siteCode

                const requestOne = axios.get(one)
                const requestTwo = axios.get(two)
                const requestThree = axios.get(three)
                const requestFour = axios.get(four)
                const requestFive = axios.get(five)
                const requestSix = axios.get(six)
                let requestSeven = false
                if (this.allow_client_bill) {
                  requestSeven = axios.get(seven)
                }
                const requestEight = axios.get(eight)
                this.$store.state.questions = []
                await axios.all([requestOne, requestTwo, requestThree, requestFour, requestFive, requestSix, requestSeven, requestEight])
                    .then(axios.spread((...responses) => {
                      if (responses[1].data) {
                        for (let key in responses[1].data.data.questions) {
                          if (parseInt(key) !== responses[1].data.data.questions.length) {
                            responses[1].data.data.questions[key].multiple = []
                            responses[1].data.data.questions[key].multiple_ids = []
                            this.$store.state.questions.push(responses[1].data.data.questions[key])
                          }
                        }
                      }
                      this.$store.state.requirements = {...this.$store.state.requirements, ...responses[0].data}
                      if (this.$store.state.site.insurance_name_insured.length && this.$store.state.site.insurance_name_insured[0].length > 0) {
                        if (this.$store.state.requirements.gender) {
                          this.$store.state.requirements.gender.required_portal = '1'
                        } else {
                          this.$store.state.requirements.gender = []
                          this.$store.state.requirements.gender.required_portal = '1'
                        }
                        if (this.$store.state.requirements.address) {
                          this.$store.state.requirements.address.required_portal = '1'
                        } else {
                          this.$store.state.requirements.address = []
                          this.$store.state.requirements.address.required_portal = '1'
                        }
                      }
                      this.$store.state.configs.ALLOW_DRIVER_LICENSE = this.$store.state.requirements.driver_license_image && this.$store.state.requirements.driver_license_image !== ''
                      this.$store.state.configs.REQUIRED_DRIVER_LICENSE = this.checkRequirement('driver_license_image')
                      this.$store.state.configs.ALLOW_INSURANCE_CARD = this.$store.state.requirements.insurance_card_image && this.$store.state.requirements.insurance_card_image !== ''
                      this.$store.state.configs.REQUIRED_INSURANCE_CARD = this.checkRequirement('insurance_card_image')
                      this.$store.state.insurance = responses[2].data
                      this.$store.state.ethnicity = responses[3].data
                      this.$store.state.race = responses[4].data
                      this.$store.state.gender = responses[5].data
                      this.$store.state.allows_client_bill = responses[6].data
                      this.$store.state.calculations = responses[7].data
                      this.$store.state.allCallsDone = true
                      this.$emit('disabledSubmitButton', false)
                      if ((this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && this.$store.state.insuranceType === 'cash') || this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
                        this.$store.state.paymentProcess = true
                      }
                      if (this.$store.state.site.schedule.data.length && this.$store.state.configs.ALLOW_SCHEDULES) {
                        this.$store.state.allowSchedules = true
                      } else {
                        this.$store.state.allowSchedules = false
                      }
                    })).catch(errors => {
                      console.log('Error' + errors)
                    })
                if (nextPage && this.validateTransaction && this.$store.state.configs['SINGLE_PAGE_ORDERS'] === false) {
                  this.$emit('disabledSubmitButton', false)
                  this.jumpToTheNextPage()
                }
              }
              resolve(true)
            }).catch(() => {
              this.$store.state.invalidSiteCode = true
              this.$validator.errors.add({field: 'siteCode', msg: 'Invalid Code or server issues!'})
              let field = this.$validator._resolveField('siteCode')
              field.setFlags({invalid: true})
              document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
              reject(new Error('Invalid site code!!'))
            })
          })
        } else {
          this.$validator.errors.add({field: 'siteCode', msg: 'Office Location Code is required!'})
          let field = this.$validator._resolveField('siteCode')
          field.setFlags({invalid: true})
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          this.validatedSectionClass = 'invalid-section-class'
          this.generalClass = 'general-invalid-section'
          return false
        }
      }
    },
    computed: {
      verbiage () {
        return this.$store.state.configs.OFFICE_LOCATION_VERBIAGE
      },
      ...mapFields(['siteCode'])
    },
    watch: {
      'model.siteCode': {
        handler: function (before, after) {
          if (this.modelValidations.siteCode.required) {
            if (this.model.siteCode.length > this.modelValidations.siteCode.min - 1 && /\S/.test(this.model.siteCode)) {
              this.validatedSectionClass = 'validated-section-class'
              this.generalClass = 'general-inactive-section'
            } else {
              this.validatedSectionClass = 'invalid-section-class'
              this.generalClass = 'general-invalid-section'
            }
          } else {
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

  #siteCode{
    text-transform: uppercase;
  }

  >>> .language{
    margin: 0px !important;
    margin-top: 10px !important;
  }

  .pb-5 {
    padding-bottom: 5px;
  }

  .general-inactive-section:focus-within {
    border-left-color: $primary-color !important;
  }

  @media (max-width: 992px){
    #mobile-language{
      display: none;
    }
  }

  .pl-0{
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/SiteSelectionStep.vue